import React, { useState, useEffect, useRef } from 'react';
import Header from '../../Components/Header/Header'
import LeftMenu from '../../Components/LeftMenu/LeftMenu'
import TopMenu from '../../Components/TopMenu/TopMenu';

import Reply2 from "../../assets/images/reply2.png";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { Button, Tabs, Tab } from 'react-bootstrap';
import TruckConfirm from './TruckConfirm';

const QuoteRequest = () => {

    const editc = localStorage.getItem('TruckConf')
    const isMounted = useRef(null)
    const [isLoading, setIsLoading] = useState(true)
    const [truckConf, setTruckConf] = useState(editc);
    const [gridData, setGridData] = useState({
        All: [],
        Open: [],
        Booked: [],
        Rejected: []
    });
    const [activeTab, setActiveTab] = useState('All');
    const gridRefs = {
        All: useRef(null),
        Open: useRef(null),
        Booked: useRef(null),
        Rejected: useRef(null),
    };

    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setTruckConf(editc);
        setGridData({ All: {} });
        isMounted.current = true;
    }, []);

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        // setFilterApplied(false);
        // if (selectedRowData) {
        //     setSelectedRowData(null)
        // }
        // setGridSelect([]);
        // setIsLoading(true);
        if (tab == 'All') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else if (tab == 'Open') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Open: {} });
            }, 1);
        } else if (tab == 'Booked') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Booked: {} });
            }, 1);
        } else if (tab == 'Rejected') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Rejected: {} });
            }, 1);
        }
    };

    useEffect(() => {

        if (gridRefs[activeTab].current) {

            // if (gridData[activeTab]) {
                var token = "Bearer " + (localStorage.Trucking);
                const source = {

                    url: `${process.env.REACT_APP_RFS_URL}quote-request-list?tab=${activeTab}`, // tab_name=${orderType}&
                    beforeSend: function (jqXHR) {
                        jqXHR.setRequestHeader('Authorization', token);
                    },
                    datatype: 'json',
                    id: `${activeTab}-`,
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'requested_by', type: 'string' },
                        { name: 'status', type: 'string' },
                        { name: 'respond_option', type: 'string' },
                        { name: 'pickup_location', type: 'string' },
                        { name: 'delivery_location', type: 'string' },
                        { name: 'requested_date', type: 'string' },
                        { name: 'truck_request_id', type: 'string' },
                    ],
                    // localdata: localData,
                };

                const dataAdapter = new window.$.jqx.dataAdapter(source);
                const columns = [
                    // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
                    {
                        text: 'Reply to request',
                        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                            return '<div class="grid_actions"><div class="row_trconf" ><img src="' + Reply2 + '" /> Reply </div></div>'; // <div><img src="' + view + '" class="row_update" /></div>

                        },
                        width: '7%', filterable: false,
                    },
                    { text: 'Requested By', filtertype: 'textbox', datafield: 'requested_by', width: '10%', cellclassname: '', },
                    { text: 'Status', filtertype: 'textbox', datafield: 'status', width: '10%', cellclassname: '', },
                    { text: 'Respond Option', filtertype: 'textbox', datafield: 'respond_option', width: '10%', cellclassname: '', },
                    { text: 'Pickup Location', filtertype: 'textbox', datafield: 'pickup_location', width: '10%', cellclassname: '', },
                    { text: 'Delivery Location', filtertype: 'textbox', datafield: 'delivery_location', width: '10%', cellclassname: '', },
                    { text: 'Requested Date', filtertype: 'textbox', datafield: 'requested_date', width: '10%', cellclassname: '', },
                ];

                const gridOptions = {
                    width: '100%',
                    source: dataAdapter,
                    columns: columns,
                    autoheight: true,
                    sortable: true,
                    altrows: false,
                    enabletooltips: true,
                    editable: false,
                    selectionmode: 'checkbox',
                    pageable: false,
                    pageSize: 10,
                    pagerButtonsCount: 5,
                    pagerMode: 'advanced',
                    filterable: true,
                    filterrowheight: 45,
                    showfilterrow: true,
                    rowsheight: 42,
                    columnsheight: 45,

                };

                window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
                window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');

                window.$(gridRefs[activeTab].current).on('rowclick', (event) => {
                    // console.log('event', event);
                    const args = event.args.row.bounddata;
                    // console.log('args', args);
                    const sendRowId = gridData[activeTab];
                    // setSelectedRowData({ args, station_id: args.id });

                    // setShowDetails(true);
                });
                window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                    window.$(row).on('mouseover', () => {
                        window.$(row).addClass('row-hover');
                    });
                    window.$(row).on('mouseout', () => {
                        window.$(row).removeClass('row-hover');
                    });
                });
                window.$(gridRefs[activeTab].current).on('click', '.row_trconf', function (event) {
                    const rowDiv = window.$(this).closest('[role="row"]');
                    const rowIndex = window.$(rowDiv).attr('row-id');
                    const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                    if (boundIndex !== undefined) {
                        const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                        const pageIndex = pagingInfo.pagenum;
                        const pageSize = pagingInfo.pagesize;
                        const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                        // console.log('Global Index:', globalIndex); 
                        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                        if (rowData) {
                            // loadDetails('M', rowData.service_recovery_id);
                            setIsLoading(true);
                            setTruckConf(true);
                            localStorage.setItem('TruckConf', true)
                            setTruckConfId(rowData.truck_request_id)
                        } else {
                            console.error('No data found for the given row index.');
                        }
                    } else {
                        console.error('Bound index could not be retrieved. Check the row index and data binding.');
                    }
                });
                // row selection by checkbox
                // window.$(gridRefs[activeTab].current).on('rowselect', (event) => {

                //     if (event.args.row) {

                //         const selectedRow = event.args.row.id;

                //         if (!gridSelect.includes(selectedRow)) {
                //             setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
                //         }
                //         setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
                //     } else {
                //         // Handle "Select All" case
                //         // const allIds = planData.map(row => row.booking_id);
                //         // console.log("All IDs:", allIds);
                //         // setGridSelect(allIds);
                //         console.log("Select All triggered");
                //     }
                // });
                // window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                //     if (event.args.row) {
                //         const unselectedRowId = event.args.row.id;
                //         setGridSelect(prevSelection => prevSelection.filter(id => id !== unselectedRowId));
                //     } else {
                //         setGridSelect([]);
                //     }
                // });
                // End row selection 

            // } else {
            //     const columns = [
            //         { text: 'Stations', filtertype: 'textbox', datafield: 'STN', width: '50%' },
            //         { text: 'Total Address', filtertype: 'textbox', datafield: 'Taddrs', width: '50%' },
            //     ];
            // }
        }
    }, [gridData]);


    const [truckConfId, setTruckConfId] = useState('');

    const backToQuote = () => {
        window.location.href = '/QuoteRequest'
        // setTruckConf(false);
        localStorage.setItem('TruckConf', false)
        // setIsLoading(false)
        // setTimeout(() => {
        //     if (gridRefs[activeTab]?.current) {
        //         window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
        //     }
        // }, 50);

        // if (activeTab == 'All') {
        //     setTimeout(() => {
        //         setIsLoading(false);
        //         setGridData({ Active: {} });
        //     }, 1);
        // } else if (activeTab == 'Open') {
        //     setTimeout(() => {
        //         setIsLoading(false);
        //         setGridData({ Open: {} });
        //     }, 1);
        // } else if (activeTab == 'Booked') {
        //     setTimeout(() => {
        //         setIsLoading(false);
        //         setGridData({ Booked: {} });
        //     }, 1);
        // } else if (activeTab == 'Rejected') {
        //     setTimeout(() => {
        //         setIsLoading(false);
        //         setGridData({ Rejected: {} });
        //     }, 1);
        // }
    }

    return (
        <div className="">
            {console.log('truckConfId', truckConf)}
            {console.log('active tab', activeTab)}
            <Header logo_url='/QuoteRequest' />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab position-relative">
                        {truckConf == true ?
                            <>
                                <button className='backbtn' onClick={backToQuote}> <FontAwesomeIcon icon={faArrowLeft} /> Back</button>
                                <TruckConfirm trCfId={truckConfId} />
                            </>
                            :
                            <>
                                <TopMenu module='RFS' />
                                <div className='trashdonload'>

                                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                                        <Tab eventKey="All" title={<span>All </span>} className='moveto'>
                                            {/* <Loader isLoading={isLoading} /> */}
                                            {/* {!isLoading && <>
                                        {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                        <div ref={gridRefs.Active} className='bookinggrid' ></div>
                                    </>
                                    } */}
                                            {!isLoading && <div ref={gridRefs.All} className='bookinggrid' ></div>}
                                        </Tab>
                                        <Tab eventKey="Open" title={<span>Open </span>} className='moveto'>
                                            {/* <Loader isLoading={isLoading} /> */}
                                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                                            {!isLoading && <div ref={gridRefs.Open} className='bookinggrid' ></div>}
                                            {/* <div ref={gridRefs.Open} className='bookinggrid' ></div> */}
                                        </Tab>
                                        <Tab eventKey="Booked" title={<span>Booked </span>} className='moveto'>
                                            {/* <Loader isLoading={isLoading} /> */}
                                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                                            {!isLoading && <div ref={gridRefs.Booked} className='bookinggrid' ></div>}
                                            {/* <div ref={gridRefs.Booked} className='bookinggrid' ></div> */}
                                        </Tab>
                                        <Tab eventKey="Rejected" title={<span>Rejected </span>} className='moveto'>
                                            {/* <Loader isLoading={isLoading} /> */}
                                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                                            {!isLoading && <div ref={gridRefs.Rejected} className='bookinggrid' ></div>}
                                            {/* <div ref={gridRefs.Rejected} className='bookinggrid' ></div> */}
                                        </Tab>
                                    </Tabs>

                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuoteRequest
